module.exports = __webpack_public_path__ + "static/media/busd.5ca3113f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/busd.svg
// module id = 850
// module chunks = 7